export default {
  SET_SECTIONS(state, data) {
    state.sections = data
  },
  SET_SECTIONS_FOR_SELECT(state, data) {
    state.sectionsForSelect = data
  },
}